import styled from 'styled-components';
import { fontUi } from '../../../../theme/typography';

export const StyledFormCard = styled.div`
  width: 100%;
  min-width: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;

  h1,
  h2,
  h3,
  h4 {
    display: none;
  }
`;

export const StyledFormHead = styled.div`
  ${fontUi};
  display: grid;
  grid-template-columns: 1fr auto 28px;
  gap: 8px;
  align-items: center;
  padding: 8px 4px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: ${({ theme }) => theme.textFaint};
`;

export const StyledFormRow = styled.button`
  ${fontUi};
  display: grid;
  grid-template-columns: 1fr auto 28px;
  gap: 8px;
  align-items: center;
  width: 100%;
  margin: 0;
  padding: 8px 4px;
  border: 0;
  border-top: 1px solid ${({ theme }) => theme.borderSubtle};
  background: ${({ $own, theme }) => {
    if (!$own) return 'transparent';
    return theme.isDark ? 'rgba(14, 74, 251, 0.24)' : 'rgba(14, 74, 251, 0.12)';
  }};
  color: ${({ theme }) => theme.text};
  text-align: left;
  cursor: pointer;

  &:hover {
    background: ${({ $own, theme }) =>
      $own
        ? theme.isDark
          ? 'rgba(14, 74, 251, 0.32)'
          : 'rgba(14, 74, 251, 0.18)'
        : theme.hover};
  }
`;

export const StyledFormTeam = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;

  img {
    width: 20px;
    height: 20px;
    object-fit: contain;
    flex-shrink: 0;
  }

  strong {
    ${fontUi};
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const StyledFormPills = styled.span`
  display: flex;
  gap: 4px;
  flex-shrink: 0;
`;

export const StyledFormPill = styled.span`
  ${fontUi};
  display: grid;
  place-items: center;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  font-size: 9px;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  background: ${({ $result, theme }) => {
    if ($result === 'W') return '#00b56a';
    if ($result === 'L') return '#e94235';
    if ($result === 'D') return theme.textFaint;
    return 'transparent';
  }};
  border: ${({ $result, theme }) =>
    $result ? '0' : `1px solid ${theme.border}`};
`;

export const StyledFormCs = styled.span`
  ${fontUi};
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  color: ${({ theme }) => theme.text};
`;

export const StyledFormEmpty = styled.p`
  ${fontUi};
  margin: 0;
  padding: 24px 8px;
  text-align: center;
  color: ${({ theme }) => theme.textFaint};
  font-size: 13px;
`;
